export const API_DIRECTORY = { DOC_ROOT: '' }

export const urlConstants = {
  BASE_URL: process.env.REACT_APP_ENV_URL,
  PROVIDER_API: process.env.REACT_APP_CAREPOINT_URL,
  GEOLOCATION_API: 'https://nominatim.openstreetmap.org/',
} as const

export const API_INTERFACE = {
  FIND_MEMBER: '/getMembers',
  GET_MEMBER_DETAIL: '/getMemberDetail',
  GET_SPECIALTY_LIST: '/getSpecialties',
  GET_AREA_OF_FOCUS: '/getAreaOfFocus',
  GET_LOCATION: '/getLocation',
  FIND_PROVIDERS: '/getProviders',
  GET_MANAGEMENT_REFERRAL_LIST: '/getReferrals',
  VALIDATE_REFERRAL_EXTENSION: '/validateReferralExtension',
  EXTEND_REFERRAL: '/extendReferral',
  SUBMIT_REFERRAL_PROVIDER: '/submitReferral',
  PROVIDER_DETAILS: '/getProviderDetail',
  SIGN_IN_USER: '/login',
  GET_USER: '/getUser',
  GET_PLAN_DETAIL: '/getPlanDetail',
  FORGET_PASSWORD: '/forgotPassword',
  SEND_ACCESS_CODE: '/sendAccessCode',
  GET_MEDICAL_NEIGHBORHOOD: '/getMedicalNeighborhood',
  GET_ASSIGNED_MEMBERS: '/getAssignedMembers',
  GET_CLIENT_LIST: '/getClientList',
  GET_GMAP_KEY: '/getGMapKey',
  GET_DOCTORS_BY_SERVICE_LINES: '/getDoctorsByServiceLines',
  GET_FACILITIES_BY_SERVICE_LINES: '/getFacilitiesByServiceLines',
  GET_SERVICE_LINES: '/getServiceLines',
  GET_PRACTITIONERS_BY_SERVICE_LINES: '/getPractitionersByServiceLines',
  GET_REFERRAL_MEMBER: '/getReferralMember',
  FETCH_OPENSEARCH_PROVIDERS: 'provider/fetch',
  FETCH_OPENSEARCH_PROVIDERS_BY_ZIPCODE: 'provider/zipCode',
  FETCH_OPENSEARCH_PROVIDERS_BY_PRACTICEID: 'provider/practiceId',
  FETCH_OPENSEARCH_FACILITIES: 'facility/fetch',
  FETCH_OPENSEARCH_FACILITIES_BY_ZIPCODE: 'facility/opensearch/zipCode',
  FETCH_OPENSEARCH_PRACTICES_BY_ZIPCODE: 'practice/zipCode'
} as const

export const uriConstants = {
  FIND_MEMBER_API: urlConstants.BASE_URL + API_INTERFACE.FIND_MEMBER,
  GET_MEMBER_DETAIL_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_MEMBER_DETAIL,
  GET_SPECIALTY_LIST_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_SPECIALTY_LIST,
  GET_AREA_OF_FOCUS_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_AREA_OF_FOCUS,
  GET_LOCATION_API: urlConstants.BASE_URL + API_INTERFACE.GET_LOCATION,
  FIND_PROVIDERS_API: urlConstants.BASE_URL + API_INTERFACE.FIND_PROVIDERS,
  GET_MANAGEMENT_REFERRAL_LIST_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_MANAGEMENT_REFERRAL_LIST,
  EXTEND_REFERRAL_API: urlConstants.BASE_URL + API_INTERFACE.EXTEND_REFERRAL,
  SUBMIT_REFERRAL_PROVIDER_API:
    urlConstants.BASE_URL + API_INTERFACE.SUBMIT_REFERRAL_PROVIDER,
  GET_PROVIDER_DETAIL: urlConstants.BASE_URL + API_INTERFACE.PROVIDER_DETAILS,
  GET_SIGN_IN_USER: urlConstants.BASE_URL + API_INTERFACE.SIGN_IN_USER,
  GET_PLAN_DETAIL: urlConstants.BASE_URL + API_INTERFACE.GET_PLAN_DETAIL,
  FORGET_PASSWORD: urlConstants.BASE_URL + API_INTERFACE.FORGET_PASSWORD,
  SEND_ACCESS_CODE: urlConstants.BASE_URL + API_INTERFACE.SEND_ACCESS_CODE,
  GET_MEDICAL_NEIGHBORHOOD:
    urlConstants.BASE_URL + API_INTERFACE.GET_MEDICAL_NEIGHBORHOOD,
  GET_USER: urlConstants.BASE_URL + API_INTERFACE.GET_USER,
  GET_ASSIGNED_MEMBERS_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_ASSIGNED_MEMBERS,
  GET_CLIENT_LIST: urlConstants.BASE_URL + API_INTERFACE.GET_CLIENT_LIST,
  GET_GMAP_KEY: `${urlConstants.BASE_URL}/getGMapKey`,
  GET_REFERRAL_MEMBER_API:
    urlConstants.BASE_URL + API_INTERFACE.GET_REFERRAL_MEMBER,
  VALIDATE_REFERRAL_EXTENSION_API:
    urlConstants.BASE_URL + API_INTERFACE.VALIDATE_REFERRAL_EXTENSION,
}
